export default __webpack_public_path__ + "static/stub_cover-60768bc468ce94d1f6a2cd74cb5ac1af.webp";